export enum DisputesColumns {
	id = "Id",
	org = "Org",
	source = "Source",
	amount = "Amount",
	createdAt = "Created At",
	status = "Status",
	updatedAt = "Updated At",
	customerName = "Customer Name",
	customerId = "Customer Id",
}

export type AllowedDisputesColumns =
	| DisputesColumns.id
	| DisputesColumns.org
	| DisputesColumns.customerName
	| DisputesColumns.customerId
	| DisputesColumns.status
	| DisputesColumns.source
	| DisputesColumns.createdAt
	| DisputesColumns.updatedAt
	| DisputesColumns.amount
